import { render } from "./Validate.vue?vue&type=template&id=774b7f56&scoped=true"
import script from "./Validate.vue?vue&type=script&lang=js"
export * from "./Validate.vue?vue&type=script&lang=js"

import "./Validate.vue?vue&type=style&index=0&id=774b7f56&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774b7f56"]])

export default __exports__